module.exports = __webpack_public_path__ + "40d9c69cc2867f333147f8523c64d7d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/client/images/b_negative.svg
// module id = 981
// module chunks = 0